<template>
  <div class="jm-mb-3">
    <label
      v-if="label"
      class="jm-d-inline-block jm-mb-2"
      data-test="checkbox-group-label"
      >{{ label }}</label
    >
    <BaseCheckBox
      v-for="option in options"
      :key="`${option.value}-${name}`"
      :id="`${option.value}-${name}`"
      :label="option.label"
      :value="option.value"
      :checked="modelValue.includes(option.value)"
      :name="name"
      @update:checked="check(option.value, $event)"
      data-test="checkbox-input"
    />
  </div>
</template>

<script>
import BaseCheckBox from '@/components/molecules/form/BaseCheckBox.vue'
export default {
  name: 'BaseCheckBoxGroup',
  components: { BaseCheckBox },
  props: {
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    modelValue: {
      type: Array,
      required: true
    }
  },
  methods: {
    check(value, checked) {
      let updatedModelValue = []
      if (checked) {
        updatedModelValue = [...this.modelValue, value]
      } else {
        updatedModelValue = this.modelValue.filter(
          modelValue => modelValue !== value
        )
      }
      this.$emit('update:modelValue', updatedModelValue)
    }
  }
}
</script>
